import { Questions } from './questions';

export class Pages {
    Page_no: number;
    isSoftRequiredHandle: boolean = false;
    isEndSurvey: boolean;
    Questions: Questions[];
    isAllQuestionsHide: boolean;
    isPageLoadComplete: boolean;
}

export class Group {
    group_no: number;
    gtitle: string;
    PipeGTitle: string;
    QuestionTip: string;
    L_text: string;
    H_text: string;
    M_text: string;
    M_Pos: number;
    Matrix_id: number;
    colwidth: number;
    isAnchorReverse: boolean;
    ShowDemoSubQno: boolean;
    answer_style: number;
    isOverAllStyleApplied: boolean;
    pipeTitle:string;
    mgTextboxHeight: number;
    IsScribbledSignature: boolean;
    IsUploadImageSignature: boolean;
    IsTypeSignature: boolean;
}

export class Matrix{
    matrix_id: number;
    Mtitle: string;
    PipeMTitle: string;
    questiontip: string;
    QPos: number;
    isMulti: boolean;
    MultiColumnCount: number;
    subq_col_width: number;
    totalwidth: number;
    VerticalSpaceCount: number;
    IsSingleGrid: boolean;
    isBranchEnabled: boolean;
    SourceGrid: number;
    SourcePosition: number;
    SourceNumber: number;
    TargetGrid: number;
    isDisplayManage: boolean;
    isOverAllStyleApplied: boolean;
    isHiddenQ: boolean;
}

export class GroupPiping {
    group_no: number;
    pipeTitle: string;
}

export class MatrixPiping {
    matrix_id: number;
    pipeTitle: string;
}

export class MatrixRandomiseList {
    matrix_id: number;
    uniqueList: any;
}


